import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService, TiposCalculos } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { ConveniosService } from "../../../services/convenios.service";
import { NominasService } from "../../../services/creditos/nominas.service";


@Component({
    selector: 'nomina-simulador',
    templateUrl: './nomina-simulador.component.html',
    styleUrls: ['./nomina-simulador.component.scss'],
  })

export class NominaSimuladorComponent implements OnInit {
    //UI
    public cliente: any = {};
    public prestamo: any = {};
    public catalogoPeriodicidad: any = {};
    public catalogoTipoCalculo: any = {};
    public errors:any = {};
    public procesandoCalculo: boolean = false;
    //Nomina
    public convenios: any [] = [];
    public nomina: any = {};
    public convenioSelected: any = '';
    public calculoLabel: string = null;
    //Opciones de crédito
    public plazoSelected: string = null;
    public creditoMaximo6m: number = null;
    public customValue6m: number = null;
    public creditoMaximo7m: number = null;
    public customValue7m: number = null;
    public creditoMaximo12m: number = null;
    public customValue12m: number = null;
    public creditoMaximo13m: number = null;
    public customValue13m: number = null;
    public creditoMaximo18m: number = null;
    public customValue18m: number = null;
    public creditoMaximo24m: number = null;
    public customValue24m: number = null;
    public creditoMaximo30m: number = null;
    public customValue30m: number = null;
    //Porcentajes
    public porcentajePension: number = null;
    public porcentajeInfonabit: number = null;
    public porcentajeImss: number = null;
    public porcentajeFonacot: number = null;
    public porcentajeProfinmex: number = null;
    public porcentajeOtros: number = null;
    public porcentajeDeducciones: number = null;
    public porcentajeSaldo: number = null;
    //Subscriptions
    private sub: any;
    //Edit mode
    private id : number = null;

    constructor(
      private helperService: HelpersService,
      public location: Location,
      private creditosService: CreditosService,
      private activeRoute: ActivatedRoute,
      private router: Router,
      private conveniosService: ConveniosService,
      private nominaService: NominasService
    ){
    }

    public ngOnInit() {
        this.getConvenios();
        this.setDefaultValues();
        this.sub = this.activeRoute.params.subscribe(params => {
            if(params['id']){
                //Edit mode
                this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
                this.getCredito(this.id);
            } 
        });
    }

    private setDefaultValues(){
        this.catalogoPeriodicidad = this.creditosService.getCatalogoPeriodicidad();
        this.prestamo.plazo_medida = 'meses';
    }

    public getCredito(idCredito : number){    
        this.nominaService.get(idCredito).subscribe(
            (response: any)=>
            {
                const result = response.json().content;
                this.prestamo = result.credito.prestamo;
                this.cliente = result.credito.cliente;
                this.nomina = result.nomina;
                this.selectConvenio(this.nomina.idConvenios);
                //Esta funcion actualiza los totales y los porcentajes de endeudamiento
                this.setPorcentajesAndTotales();
                //Obtener los montos máximos disponibles para el crédito
                this.calcularCredito();
                //Cargar el monto del crédito seleccionado
                this.setupPlazoAndMonto(result.credito.prestamo.plazo_periodo, result.credito.prestamo.monto_prestamo);
                this.showTipoCalculo(this.prestamo.calculo);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public getConvenios(){    
        this.conveniosService.getAll({tipo:"Nómina" }).subscribe(
            (response)=>
            {
            const jsonResult = response.json();
            if(jsonResult.content){
                this.convenios = response.json().content;
            }
            
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public onSelectConvenio(){
        if(this.convenioSelected && this.convenioSelected.id){
            //Caso cuando se selecciona un convenio válido
            this.nomina.idConvenios = this.convenioSelected.id;
            this.prestamo.calculo = this.convenioSelected.calculo;
            this.prestamo.periodicidad = this.convenioSelected.periodicidad;
            this.prestamo.tasa = this.convenioSelected.tasa_interes;

            this.showTipoCalculo(this.prestamo.calculo);
        }else{
            //Caso cuando se selecciona un convenio no válido
            this.nomina.idConvenios = null;
            this.prestamo.calculo = null;
            this.prestamo.periodicidad = null;
            this.prestamo.tasa = null;
        }
    }

    public showTipoCalculo(tipoCalculo: number){
        switch(tipoCalculo){
            case TiposCalculos.Insoluto:
                this.calculoLabel = 'Insoluto';
                break;
            case TiposCalculos.Soluto:
                this.calculoLabel = 'Soluto';
                break;
            case TiposCalculos.Simple:
                this.calculoLabel = 'Simple';
                break;
        }
    }

    public onPorcentajeChange(campo: string){
        //Al cambiar los parámetros del crédito hay que restablecer los montos del crédito
        this.restablecerMontosCredito();

        if(!this.nomina.sueldo_bruto || Number(this.nomina.sueldo_bruto) === 0){
            return false;
        }

        const sueldo_bruto = this.nomina.sueldo_bruto;
        switch(campo){
            case 'pension':
                this.porcentajePension = this.calculatePorcentajeDeduccion(this.nomina.pension, sueldo_bruto);
                break;
            case 'infonavit':
                this.porcentajeInfonabit = this.calculatePorcentajeDeduccion(this.nomina.infonavit, sueldo_bruto);
                break;
            case 'imss':
                this.porcentajeImss = this.calculatePorcentajeDeduccion(this.nomina.imss, sueldo_bruto);
                break;
            case 'fonacot':
                this.porcentajeFonacot = this.calculatePorcentajeDeduccion(this.nomina.fonacot, sueldo_bruto);
                break;
            case 'profimex':
                this.porcentajeProfinmex = this.calculatePorcentajeDeduccion(this.nomina.profimex, sueldo_bruto); 
                break;
            case 'otros':
                this.porcentajeOtros = this.calculatePorcentajeDeduccion(this.nomina.otros, sueldo_bruto);
                break;
        }

        this.nomina.totalDeducciones = this.calculateTotalDeducciones();
        this.porcentajeDeducciones = this.calculatePorcentajeDeduccion(this.nomina.totalDeducciones, sueldo_bruto);
        this.nomina.totalSaldo = this.nomina.totalEndeudamiento - (this.nomina.totalDeducciones ? this.nomina.totalDeducciones : 0);
        this.porcentajeSaldo = this.calculatePorcentajeDeduccion(this.nomina.totalSaldo, sueldo_bruto);
    }

    public onSueldoBrutoChange(){
        //Al cambiar los parámetros del crédito hay que restablecer los montos del crédito
        this.restablecerMontosCredito();

        if(!this.nomina.sueldo_bruto || Number(this.nomina.sueldo_bruto) === 0){
            this.porcentajePension = null;
            this.porcentajeInfonabit = null;
            this.porcentajeImss = null;
            this.porcentajeFonacot = null;
            this.porcentajeProfinmex = null;
            this.porcentajeOtros = null;
        }else{
            this.setPorcentajesAndTotales();
        }
    }

    private setPorcentajesAndTotales(){
        const sueldo_bruto = this.nomina.sueldo_bruto;
        this.porcentajePension = this.calculatePorcentajeDeduccion(this.nomina.pension, sueldo_bruto);
        this.porcentajeInfonabit = this.calculatePorcentajeDeduccion(this.nomina.infonavit, sueldo_bruto);
        this.porcentajeImss = this.calculatePorcentajeDeduccion(this.nomina.imss, sueldo_bruto); 
        this.porcentajeFonacot = this.calculatePorcentajeDeduccion(this.nomina.fonacot, sueldo_bruto); 
        this.porcentajeProfinmex = this.calculatePorcentajeDeduccion(this.nomina.profimex, sueldo_bruto); 
        this.porcentajeOtros = this.calculatePorcentajeDeduccion(this.nomina.otros, sueldo_bruto);  

        //Actualizar el valor de los montos totales y sus porcentajes
        //El nivel del endeudamiento es del 35%
        // this.nomina.totalEndeudamiento = (this.nomina.sueldo_bruto * 35) /100;
        console.log(this.convenioSelected.endeudamiento_max);
        this.nomina.totalEndeudamiento = (this.nomina.sueldo_bruto * this.convenioSelected.endeudamiento_max) /100;
        
        //Deducciones
        this.nomina.totalDeducciones = this.calculateTotalDeducciones();
        this.porcentajeDeducciones = this.calculatePorcentajeDeduccion(this.nomina.totalDeducciones, sueldo_bruto);
        //Saldo
        this.nomina.totalSaldo = this.nomina.totalEndeudamiento - (this.nomina.totalDeducciones ? this.nomina.totalDeducciones : 0);
        this.porcentajeSaldo = this.calculatePorcentajeDeduccion(this.nomina.totalSaldo, sueldo_bruto);
    }

    public calcularCredito(){
        this.errors = this.nominaService.validateCapacidadPago(this.nomina);
        
        if (Object.entries(this.errors).length > 0) {
          return false;
        }
        if (this.porcentajeSaldo<0){
            alert("El porcentaje de saldo no pude ser negativo");
        }else{
            //TODO: Que un solo servicio haga la consulta para obtener la información de los diferentes plazos (manda un array con los meses que se quiere calcular)
            if(this.prestamo.calculo === TiposCalculos.Insoluto){
                //Proyección 6 meses
                this.getCreditoMaximoInsoluto(6,'meses');
                //Proyección 7 meses
                this.getCreditoMaximoInsoluto(7,'meses');
                //Proyección 12 meses
                this.getCreditoMaximoInsoluto(12,'meses');
                //Proyección 13 meses
                this.getCreditoMaximoInsoluto(13,'meses');
                //Proyección 18 meses
                this.getCreditoMaximoInsoluto(18,'meses');
                //Proyección 24 meses
                this.getCreditoMaximoInsoluto(24,'meses');
                //Proyección 30 meses
                this.getCreditoMaximoInsoluto(30,'meses');
            }else if(this.prestamo.calculo === TiposCalculos.Soluto){
                //Proyección 6 meses
                this.getCreditoMaximoSoluto(6,'meses');
                //Proyección 7 meses
                this.getCreditoMaximoSoluto(7,'meses');
                //Proyección 12 meses
                this.getCreditoMaximoSoluto(12,'meses');
                //Proyección 13 meses
                this.getCreditoMaximoSoluto(13,'meses');
                //Proyección 18 meses
                this.getCreditoMaximoSoluto(18,'meses');
                //Proyección 24 meses
                this.getCreditoMaximoSoluto(24,'meses');
                //Proyección 30 meses
                this.getCreditoMaximoSoluto(30,'meses');
            }

        }

    }

    private getCreditoMaximoInsoluto(plazo_periodo : number, plazo_medida : string){
        this.nominaService.getCreditoMaximoInsoluto(this.prestamo.tasa, this.nomina.totalSaldo, plazo_periodo, plazo_medida, this.prestamo.periodicidad).subscribe(
            (response)=>
            {
                const result = response.json().content;
                this.setCreditoMaximo(plazo_periodo, result.monto);

            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
  
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    private getCreditoMaximoSoluto(plazo_periodo : number, plazo_medida : string){
        this.nominaService.getCreditoMaximoSoluto(this.prestamo.tasa, this.nomina.totalSaldo, plazo_periodo, plazo_medida, this.prestamo.periodicidad).subscribe(
            (response)=>
            {
                const result = response.json().content;
                this.setCreditoMaximo(plazo_periodo, result.monto);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
  
            if(error.status == 400) {
              this.helperService.setBackendErrors(error.json().content, this.errors);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public onCustomSieteMesesChange(plazo: string){
        this.plazoSelected = plazo;
    }

    public save(){
        this.errors = {};
        let prestamo = this.getPrestamoToSave();       

        let credito = {
            idCreditos : null,
            prestamo : prestamo,
            cliente : this.cliente,
            nomina : this.nomina
        };
  
        this.errors = this.nominaService.validate(credito);

        //Si hay un error en el monto, hay que mostrar el mensaje de error en el input correspondiente
        if(this.errors.monto_maximo_prestamo){
            const montoError = this.showErrorMonto(this.errors.monto_maximo_prestamo)
            //Se agrega un nuevo item con el error correspondiente
            Object.assign(this.errors, montoError);
        }

        if (Object.entries(this.errors).length > 0) {
          return false;
        }

        if(this.id){
          //Update credito
          //set idCreditos
          credito.idCreditos = this.id;
          this.update(credito);
        }else{
          //New credito
          this.create(credito);
        }
    }

    private create(credito: any){
        this.nominaService.save(credito).subscribe(
          (response)=>
          {
            const result = response.json().content;
            //Navigate to tabla de amortizacion
            this.router.navigate(['/creditos/tabla-amortizacion/', result.id]);
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            
            if(error.status == 400) {
              this.helperService.showSaveCreditErrors(error.json().content, this.errors);
            }
          }
        );
    }

    private update(credito: any){
        this.nominaService.update(credito).subscribe(
            (response)=>
            {
            const result = response.json().content;
            //Navigate to tabla de amortizacion
            this.router.navigate(['/creditos/tabla-amortizacion/', this.id]);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
            
            if(error.status == 400) {
                this.helperService.showSaveCreditErrors(error.json().content, this.errors);
            }
            }
        );
    }

    /**
     * Helpers
     */

    private getPrestamoToSave(){
        //El plazo seleccionado esta en el modelo plazoSelected, se debe actualizar el valor en el modelo que se enviará al servicio
        let prestamo = this.prestamo;
        if(!this.plazoSelected){
            return prestamo;
        }
        
        switch(this.plazoSelected){
            case 'seis':
                prestamo.plazo_periodo = 6;
                prestamo.monto_prestamo = this.creditoMaximo6m;
                prestamo.monto_maximo = this.creditoMaximo6m;
                break;
            case 'seis-custom':
                prestamo.plazo_periodo = 6;
                prestamo.monto_prestamo = this.customValue6m;
                prestamo.monto_maximo = this.creditoMaximo6m;
                break;
            case 'siete':
                prestamo.plazo_periodo = 7;
                prestamo.monto_prestamo = this.creditoMaximo7m;
                prestamo.monto_maximo = this.creditoMaximo7m;
                break;
            case 'siete-custom':
                prestamo.plazo_periodo = 7;
                prestamo.monto_prestamo = this.customValue7m;
                prestamo.monto_maximo = this.creditoMaximo7m;
                break;
            case 'doce':
                prestamo.plazo_periodo = 12;
                prestamo.monto_prestamo = this.creditoMaximo12m;
                prestamo.monto_maximo = this.creditoMaximo12m;
                break;
            case 'doce-custom':
                prestamo.plazo_periodo = 12;
                prestamo.monto_prestamo = this.customValue12m;
                prestamo.monto_maximo = this.creditoMaximo12m;
                break;
            case 'trece':
                prestamo.plazo_periodo = 13;
                prestamo.monto_prestamo = this.creditoMaximo13m;
                prestamo.monto_maximo = this.creditoMaximo13m;
                break;
            case 'trece-custom':
                prestamo.plazo_periodo = 13;
                prestamo.monto_prestamo = this.customValue13m;
                prestamo.monto_maximo = this.creditoMaximo13m;
                break;
            case 'dieciocho':
                prestamo.plazo_periodo = 18;
                prestamo.monto_prestamo = this.creditoMaximo18m;
                prestamo.monto_maximo = this.creditoMaximo18m;
                break;
            case 'dieciocho-custom':
                prestamo.plazo_periodo = 18;
                prestamo.monto_prestamo = this.customValue18m;
                prestamo.monto_maximo = this.creditoMaximo18m;
                break;
            case 'veinticuatro':
                prestamo.plazo_periodo = 24;
                prestamo.monto_prestamo = this.creditoMaximo24m;
                prestamo.monto_maximo = this.creditoMaximo24m;
                break;
            case 'veinticuatro-custom':
                prestamo.plazo_periodo = 24;
                prestamo.monto_prestamo = this.customValue24m;
                prestamo.monto_maximo = this.creditoMaximo24m;
                break;
            case 'treinta':
                prestamo.plazo_periodo = 30;
                prestamo.monto_prestamo = this.creditoMaximo30m;
                prestamo.monto_maximo = this.creditoMaximo30m;
                break;
            case 'treinta-custom':
                prestamo.plazo_periodo = 30;
                prestamo.monto_prestamo = this.customValue30m;
                prestamo.monto_maximo = this.creditoMaximo30m;
                break;
        }
        

        return prestamo;
    }

    private setCreditoMaximo(plazo_periodo : number, monto : number){
        switch(plazo_periodo){
            case 6:
                this.creditoMaximo6m = monto;
                break;
            case 7:
                this.creditoMaximo7m = monto;
                break;
            case 12:
                this.creditoMaximo12m = monto;
                break;
            case 13:
                this.creditoMaximo13m = monto;
                break;
            case 18:
                this.creditoMaximo18m = monto;
                break;
            case 24:
                this.creditoMaximo24m = monto;
                break;
            case 30:
                this.creditoMaximo30m = monto;
                break;
        }
    }

    /**
     * Obtener el total de las deducciones
     */
    private calculateTotalDeducciones(){
        let totalDeducciones = 0;

        totalDeducciones += Number(this.nomina.pension ? this.nomina.pension : 0);
        totalDeducciones += Number(this.nomina.infonavit ? this.nomina.infonavit : 0);
        totalDeducciones += Number(this.nomina.imss ? this.nomina.imss : 0);
        totalDeducciones += Number(this.nomina.fonacot ? this.nomina.fonacot : 0);
        totalDeducciones += Number(this.nomina.profimex ? this.nomina.profimex : 0);
        totalDeducciones += Number(this.nomina.otros ? this.nomina.otros : 0);

        return totalDeducciones;
    }

    private calculatePorcentajeDeduccion(deduccion: number, sueldo_bruto: number){
        return deduccion ? ((deduccion * 100) / sueldo_bruto) : null;
    }

    private showErrorMonto(errorMessge: string){
        if(this.plazoSelected){
            let creditError = {};
            switch(this.plazoSelected){
                case 'siete':
                case 'siete-custom':
                    creditError = { monto_prestamo_siete : errorMessge};
                    break;
                case 'doce':
                case 'doce-custom':
                    creditError = { monto_prestamo_doce : errorMessge};
                    break;
                case 'trece':
                case 'trece-custom':
                    creditError = { monto_prestamo_trece : errorMessge};
                    break;
                case 'dieciocho':
                case 'dieciocho-custom':
                    creditError = { monto_prestamo_dieciocho : errorMessge};
                    break;
            }

            return creditError;
        }
    }

    private selectConvenio(idConvenio: number){
        let controller = this;
        this.convenios.forEach(function(element) {
            if(element.id === idConvenio){
                controller.convenioSelected = element;
                this.setPorcentajesAndTotales();
            }
        });       
    }

    private setupPlazoAndMonto(plazo_periodo: number, monto_prestamo: number){
        switch(plazo_periodo){
            case 6:
                this.customValue6m = monto_prestamo;
                this.plazoSelected = 'seis-custom';
                break;
            case 7:
                this.customValue7m = monto_prestamo;
                this.plazoSelected = 'siete-custom';
                break;
            case 12:
                this.customValue12m = monto_prestamo;
                this.plazoSelected = 'doce-custom';
                break;
            case 13:
                this.customValue13m = monto_prestamo;
                this.plazoSelected = 'trece-custom';
                break;
            case 18:
                this.customValue18m = monto_prestamo;
                this.plazoSelected = 'dieciocho-custom';
                break;
            case 24:
                this.customValue24m = monto_prestamo;
                this.plazoSelected = 'veinticuatro-custom';
                break;
            case 30:
                this.customValue30m = monto_prestamo;
                this.plazoSelected = 'treinta-custom';
                break;
        }
    }

    /**
     * Esta función se utiliza cuando se cambia un parámetro del crédito y sirve para restablecer
     * los máximos y el monto del crédito. Ya que estos valores dependen del sueldo y de las deducciones
     */
    private restablecerMontosCredito() {
        this.creditoMaximo6m = null;
        this.creditoMaximo7m = null;
        this.creditoMaximo12m = null;
        this.creditoMaximo18m = null;
        this.creditoMaximo24m = null;
        this.creditoMaximo30m = null;
        this.prestamo.plazo_periodo = null;
        this.prestamo.monto_prestamo = null;
        this.prestamo.monto_maximo = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/nomina/simulador/nomina-simulador.component.ts